import EventsVeiwer from '../../components/monitoring/components/EventsViewer.vue'
import EventValidator from '../../components/monitoring/components/EventValidator.vue'
import Monitoring from './../../components/monitoring/Monitoring.vue'
import Login from './../../components/shared/Login.vue'

export default [
  { 
    path: '/monitoring-central', 
    component: Monitoring, 
    name: 'monitoring',
    children: [
      {
        path: '',
        component: EventsVeiwer,
      },
      {
        path: 'validator',
        component: EventValidator,
      }
    ]
  },
  { path: '/login', component: Login, name: 'login' }
]
